import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeInvitations = data => {
  const invitation = new schema.Entity('invitations')
  return normalize(data, [invitation])
}

const ArchivedInvitationsReducer = combineReducers({
  fetchInvitationsRequest: createRequestReducer('ARCHIVED_INVITATIONS:FETCH'),
  pagination: createReducer(null, {
    'ARCHIVED_INVITATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data && response.data.assessment_file_invitations_pagination
  }),
  removeInvitationRequests: createMappedRequestReducer(
    'ARCHIVED_INVITATIONS:REMOVE'
  ),
  invitations: createReducer(null, {
    'ARCHIVED_INVITATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeInvitations(response.data.assessment_file_invitations)
  })
})

export default ArchivedInvitationsReducer
